import axios from "axios";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchExternalDocs = async ({ patientId, trialId, visitId, page }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/patient/patient/get_additional_docs/`, {
    params: {
      patient: patientId,
      trial: trialId,
      visit: visitId,
      page,
    },
    headers: { Authorization: `Token ${token}` },
  });

  return res.data;
};

const useGetExternalDocs = ({ patientId, trialId, visitId, page = 1, enabled = true }) => {
  return useQuery({
    queryKey: ["external-docs", patientId, trialId, visitId, page],
    queryFn: () => fetchExternalDocs({ patientId, trialId, visitId, page }),
    enabled: enabled && Boolean(patientId),
    placeholderData: keepPreviousData,
  });
};

export default useGetExternalDocs;
